module.exports = __webpack_public_path__ + "img/caracteristicas-arco-digi.6f6cba23.png";